// @flow
import React, { Component, Fragment } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import PunchCardModal from './PunchCardModal/PunchCardModal';
import { FormattedMessage } from 'react-intl';

import style from './PunchCard.scss';
import icons from '../../../assets/styles/icons.scss';

import type { HTTPError } from '../../../error';

type Props = {
  count?: number;
  total?: number;
  coupon?: string;
  claim: () => void;
  isClaimingPoints?: boolean;
  claimPointsError?: HTTPError;
};

type State = {
  isOpen?: boolean;
};

export default class PunchCard extends Component<Props, State> {
  state = {
    isOpen: false,
  };

  componentDidUpdate(prevProps: Props) {
    /*
    const { coupon } = this.props;
    if (!prevProps.coupon && !!coupon) {
      this.setState({
        isOpen: true,
      });
    }
    */
  }

  handleClickClaim = (e: Event) => {
    const { claim } = this.props;
    e.preventDefault();
    this.setState({ isOpen: true })
    claim();
  };

  handleClose = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { count, total, isClaimingPoints, coupon, claimPointsError } = this.props;
    const { isOpen } = this.state;
    return (
      <Fragment>
        {typeof count === 'number' && typeof total === 'number' &&
        <section className={classNames(style.punchCardWrap, { [style.disabled]: !!isClaimingPoints })}>
          {<FormattedMessage id="punchCard.count.label">{
            txt => <p className={style.title}>{txt}: <strong>{count}/{total}</strong></p>
          }</FormattedMessage>}
          {/*count === 0 && <FormattedMessage id="punchCard.zeroCount.label">{
            txt => <p className={style.title}>{txt}</p>
          }</FormattedMessage>*/}
          <article className={style.pointsWrap}>
            <div className={style.starsWrap}>
              {(new Array(count)).fill(0).map((_: any, i: number) =>
                <i key={`fill-${i}`}
                   className={classNames(icons.iconStarMedium, style.full)}/>)}
              {(new Array(total - count)).fill(0).map((_: any, i: number) =>
                <i key={`empty-${i}`}
                   className={classNames(icons.iconStarMedium, style.empty)}/>)}
            </div>
            <div className={style.giftWrap}>
              <p>=</p>
              <i className={classNames(icons.symbolGift, { [style.active]: count === total })}/>
            </div>
          </article>
          {count === total ? <FormattedMessage id="punchCard.claim">{
              txt => <a href="#"
                        className={style.claim}
                        onClick={this.handleClickClaim}>{txt}</a>
            }</FormattedMessage> :
            <FormattedMessage id="punchCard.zeroCount.label">{
              txt => <span className={style.subtitle}>{txt} <a
                href="https://www.qempo.com.pe/blog/envio-internacional-gratis/"
                target="_blank"
                className={style.question}><span>?</span></a></span>
            }</FormattedMessage>}
        </section>}
        <PunchCardModal isOpen={isOpen}
                        isClaimingPoints={isClaimingPoints}
                        handleClose={this.handleClose}
                        claimPointsError={claimPointsError}
                        coupon={coupon}/>
      </Fragment>
    );
  }
}

PunchCard.propTypes = {
  count: PropTypes.number,
  total: PropTypes.number,
  coupon: PropTypes.string,
  claim: PropTypes.func.isRequired,
  isClaimingPoints: PropTypes.bool,
  claimPointsError: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/modules/punch-card/components/PunchCard.jsx